export class BookingSearchByTextDto {

	public idReserca: string;

	public searchtext: string;
	public activeFilterKeys: Array<string>;
	public parentid: number;
	public portOriginId: number;
	public portDestinationId: number;
	public page: number = 0;
	public itemsPerPage: number = 50;
	public sliceCount = 100;

	public static buildPage(searchtext: string, activeFilterKeys: Array<string>, page: number, itemsPerPage: number): BookingSearchByTextDto {
		let result = new BookingSearchByTextDto();
		result.searchtext = searchtext;
		result.activeFilterKeys = activeFilterKeys;
		result.page = page;
		result.itemsPerPage = itemsPerPage;
		return result;
	}
}